import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../config/api';
import { 
  FaCalendarPlus, 
  FaCalendarCheck, 
  FaClipboardList, 
  FaChartBar,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaTicketAlt,
  FaClock,
  FaUsers,
  FaMapMarkedAlt
} from 'react-icons/fa';

import GlobalHeader from '../../../../components/GlobalHeader.jsx';
import '../css/Dashboard.css';

const OrganiserDash = () => {
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [forceUpdate, setForceUpdate] = useState(0);

  useEffect(() => {
    console.log('[OrganiserDash] 🏠 Dashboard mounted — no API call, static navigation only. Routes: /event-form, /requestcard, /rehost-event, /organiser-events-overview, /organiser-revenue, /ticket-sales-analysis, /time-sales-analysis, /event-performance, /geographic-events');
    const timer = setTimeout(() => {
      setLoading(false);
      setForceUpdate(prev => prev + 1); // Force re-render after loading
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleCardClick = (path) => {
    nav(path);
  };

  if (loading) {
    return (
      <div className="organiser-dashboard-container">
        <GlobalHeader 
          title="Organizer Dashboard" 
          subtitle="Manage your events and tickets"
        />
        <div className="organiser-dashboard-content">Loading...</div>
      </div>
    );
  }

  return (
    <div className="organiser-dashboard-container">
      <GlobalHeader 
        title="Organizer Dashboard" 
        subtitle="Manage your events and tickets"
      />

      <main className="organiser-dashboard-main">
        {/* SECTION 1: HERO CARD */}
        <section className="hero-section">
          <div className="hero-card-custom">
            <div className="hero-content">
              <div className="hero-left">
                <div className="hero-icon">
                  <FaTicketAlt />
                </div>
                <div className="hero-text">
                  <h2>Host a New Event</h2>
                </div>
              </div>
              <div className="hero-right">
                <button 
                  className="hero-button"
                  onClick={() => handleCardClick('/event-form')}
                >
                  Create Event
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 2: EVENT MANAGEMENT */}
        <section className="event-management-section">
          <div className="section-card">
            <div className="section-header">
              <h2>Event Management</h2>
              <p>Control and manage your hosted events</p>
            </div>
            <div className="cards-grid">
              <div 
                className="management-card"
                onClick={() => handleCardClick('/requestcard')}
              >
                <div className="card-icon">
                  <FaClipboardList />
                </div>
                <div className="card-content">
                  <h3>Event Management</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/rehost-event')}
              >
                <div className="card-icon">
                  <FaCalendarCheck />
                </div>
                <div className="card-content">
                  <h3>Rehost Event</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/organiser-events-overview')}
              >
                <div className="card-icon">
                  <FaCalendarAlt />
                </div>
                <div className="card-content">
                  <h3>My Events Overview</h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: ANALYTICS & REPORTS */}
        <section className="analytics-section">
          <div className="section-card">
            <div className="section-header">
              <h2>Analytics & Reports</h2>
            </div>
            <div className="cards-grid new-layout" key={`grid-${forceUpdate}`}>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/organiser-revenue')}
              >
                <div className="card-icon">
                  <FaMoneyBillWave />
                </div>
                <div className="card-content">
                  <h3>Revenue Dashboard</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/ticket-sales-analysis')}
              >
                <div className="card-icon">
                  <FaTicketAlt />
                </div>
                <div className="card-content">
                  <h3>Ticket Sales Analysis</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/time-sales-analysis')}
              >
                <div className="card-icon">
                  <FaClock />
                </div>
                <div className="card-content">
                  <h3>Time Sales Analysis</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/event-performance')}
              >
                <div className="card-icon">
                  <FaChartBar />
                </div>
                <div className="card-content">
                  <h3>Event Performance Dashboard</h3>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/geographic-events')}
              >
                <div className="card-icon">
                  <FaMapMarkedAlt />
                </div>
                <div className="card-content">
                  <h3>Geographic Event Distribution</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>
  );
};

export default OrganiserDash;
